var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"scalar-chart",attrs:{"width":_vm.width,"height":_vm.height,"viewBox":'0 0 '+_vm.width+' '+_vm.height}},_vm._l((_vm.data),function(d){return _c('text',{attrs:{"text-anchor":"middle","x":_vm.chartWidth/2,"y":_vm.chartHeight/2}},[_vm._v(_vm._s(_vm.numeral(d.sum).format('0,0')))])}),0)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6ae9c08","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/Components/Charts/Scalar.vue
// module id = 347
// module chunks = 0